const rowSorter = (row1, row2) => {
  if (row1.name < row2.name) {
    return -1;
  }
  if (row1.name > row2.name) {
    return 1;
  }
  return 0;
};

export default rowSorter;
